<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="手机号搜索："  label-for="key">
              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加代理</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="role_name">
          <div v-for="(item,index) in row.role_name" :key="index">
            <Tag color="blue" >{{item}}</Tag>
          </div>

        </template>
        <template slot-scope="{ row, index }" slot="avatar">
          <div class="tabBox_img">
            <img :src="row.avatar ? row.avatar : require('@/assets/images/avatar.png')">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.agent_id)">编辑</a>
          <Divider type="vertical"/>
          <a @click="editArea(row)">编辑地区</a>
          <Divider type="vertical"/>
          <a @click="del(row,'删除')">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <userEdit ref="userEdit" :id="userid" @updateStatusModel="updateStatusModel"></userEdit>
    <areaEdit ref="areaEdit" :id="userid" @updateStatusModel="updateStatusModel"></areaEdit>
    <!--删除-->
    <modalSure ref="modalSure" title="代理" :id="userid" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { agentUserList, changeStatus, delUser } from '@/api/agent'
import userEdit from './edit'
import areaEdit from './area'
import modalSure from '@/components/modalSure'
export default {
  name: 'adminUser',
  components: { userEdit, areaEdit, modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        field_key: ''
      },
      modelApi: delUser,
      dataCount: 0,
      field_key: 'all',
      userInfo: [],
      loading: false,
      userid: 0,
      columns2: [
        {
          title: '头像',
          slot: 'avatar',
          minWidth: 120
        },
        {
          title: '昵称',
          key: 'nickname',
          minWidth: 120
        },
        {
          title: '手机号',
          key: 'phone',
          minWidth: 120
        },
        {
          title: '是否启用',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '地区',
          key: 'region',
          minWidth: 120
        },
        {
          title: '总收益',
          key: 'total_balance',
          minWidth: 120
        },
        {
          title: '当月收益',
          key: 'month_balance',
          minWidth: 120
        },
        {
          title: '总流水',
          key: 'total_fee',
          minWidth: 120
        },
        {
          title: '当月流水',
          key: 'month_fee',
          minWidth: 120
        },
        {
          title: '余额',
          key: 'balance',
          minWidth: 120
        },
        {
          title: '注册时间',
          key: 'ctime',
          minWidth: 120
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 180
        }
      ]
    }
  },
  created () {
    this.userList()
  },
  methods: {
    userList () {
      this.loading = true
      this.userForm.field_key = this.field_key === 'all' ? '' : this.field_key
      agentUserList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.userList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.userList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    // 启用禁用用户
    changeSwitch (row) {
      changeStatus(row.id).then(async res => {
        this.$Message.success(res.msg)
        this.userList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    edit (id) {
      this.userid = id
      this.$refs.userEdit.isShow = true
    },
    // 添加
    add () {
      this.$refs.userEdit.isShow = true
    },
    del (row) {
      this.userid = row.agent_id
      this.$refs.modalSure.isShow = true
    },
    updateStatusModel () {
      this.reload()
    },
    closeModal (val) {
      this.userList()
    },
    editArea (row) {
      this.$router.push({ path: '/admin/agent/areaList/' + row.agent_id })
    }
  }
}
</script>
